import { ProductService } from "@/services/nextshop/product.service";

export default {
  methods: {
    async getDetailItem(idItem) {
      try {
        const response = await ProductService.getItem(idItem);
        if (response.success) {
          let importPrice = 0
          let exportPrice = 0
          response.data.prices.map((vl,idx)=>{
            if(vl.priceTypeCode === 'PRICE_IMPORT'){
              importPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
            if(vl.priceTypeCode === 'PRICE_EXPORT'){
              exportPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
          })

          return {
            ...response.data,
            appSubKey: "",
            selected: false,
            id: response.data.itemId,
            weightInGram: response.data.variations[0].weightGram,
            categoryId: response.data.category.categoryId,
            images: response.data.images.length == 0 
              ? [''] : response.data.images,
            validate: {
              sku: "",
              upc: "",
              isDisabledSKU: true,
              category: "",
              categorySub: "",
            },
            metaSearchable: {
              ...response.data.metaSearchable,
              statusDefault:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? false
                  : true,
              statusImei:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? true
                  : false,
              isSelling:
                response.data.metaSearchable.isSelling == "true" ? true : false,
            },
            options:
              response.data.options.length > 0 ? response.data.options : [],
            sku: response.data.variations[0].sku,
            upc: response.data.variations[0].upc,
            optimisticVersion: response.data.version,
            prices: response.data.prices,
            priceItem:
              response.data.prices.length > 0
                ? {
                    name: response.data.name,
                    exportPrice: exportPrice,
                    importPrice: importPrice,
                  }
                : {
                    name: response.data.name,
                    exportPrice: 0,
                    importPrice: 0,
                  },
            warranty: {
              ...response.data.warranty,
              warrantyName: response.data.warranty.description,
            },
            variations: response.data.variations.map((variation, index) => {
              let _importPrice = 0
              let _exportPrice = 0
              variation.prices.map((vl,idx)=>{
                if(vl.priceTypeCode === 'PRICE_IMPORT'){
                  _importPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
                if(vl.priceTypeCode === 'PRICE_EXPORT'){
                  _exportPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
              })

              if (response.data.options.length > 0) {
                let options = response.data.options.map((e) => e.values);
                let combinations = options.reduce((arrA, arrB) =>
                  arrA.reduce(
                    (x, y) => x.concat(arrB.map((e) => [].concat(y, e))),
                    []
                  )
                );
                return {
                  ...variation,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.value,
                      values: [option.value],
                    };
                  }),
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  itemVariationId: variation.variationId,
                  weightInGram: variation.weightGram,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                  validate: {
                    sku: "",
                    upc: "",
                    isDisabledSKU: true
                  },
                  nameOption: Array.isArray(combinations[index])
                    ? combinations[index].join("-") : combinations[index],
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                };
              } else {
                return {
                  ...variation,
                  nameOption: variation.name,
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.values[0],
                    };
                  }),
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                  itemVariationId: variation.variationId,
                  weightInGram: 0,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                };
              }
            }),
          };
        } else {
          return {}
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getDetail(params) {
      try {
        const response = await ProductService.getDetailItem(params);
        if (response.success) {
          let importPrice = 0
          let exportPrice = 0
          response.data.prices.map((vl,idx)=>{
            if(vl.priceTypeCode === 'PRICE_IMPORT'){
              importPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
            if(vl.priceTypeCode === 'PRICE_EXPORT'){
              exportPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
          })

          return {
            ...response.data,
            appSubKey: "",
            selected: false,
            id: response.data.itemId,
            weightInGram: response.data.variations[0].weightGram,
            categoryId: response.data.category.categoryId,
            images: response.data.images.length == 0 
              ? [''] : response.data.images,
            validate: {
              sku: "",
              upc: "",
              isDisabledSKU: true,
              category: "",
              categorySub: "",
            },
            metaSearchable: {
              ...response.data.metaSearchable,
              statusDefault:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? false
                  : true,
              statusImei:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? true
                  : false,
              isSelling:
                response.data.metaSearchable.isSelling == "true" ? true : false,
            },
            options:
              response.data.options.length > 0 ? response.data.options : [],
            sku: response.data.variations[0].sku,
            upc: response.data.variations[0].upc,
            optimisticVersion: response.data.version,
            prices: response.data.prices,
            priceItem:
              response.data.prices.length > 0
                ? {
                    name: response.data.name,
                    exportPrice: exportPrice,
                    importPrice: importPrice,
                  }
                : {
                    name: response.data.name,
                    exportPrice: 0,
                    importPrice: 0,
                  },
            warranty: {
              ...response.data.warranty,
              warrantyName: response.data.warranty.description,
            },
            variations: response.data.variations.map((variation, index) => {
              let _importPrice = 0
              let _exportPrice = 0
              variation.prices.map((vl,idx)=>{
                if(vl.priceTypeCode === 'PRICE_IMPORT'){
                  _importPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
                if(vl.priceTypeCode === 'PRICE_EXPORT'){
                  _exportPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
              })

              if (response.data.options.length > 0) {
                let options = response.data.options.map((e) => e.values);
                let combinations = options.reduce((arrA, arrB) =>
                  arrA.reduce(
                    (x, y) => x.concat(arrB.map((e) => [].concat(y, e))),
                    []
                  )
                );
                return {
                  ...variation,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.value,
                      values: [option.value],
                    };
                  }),
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  itemVariationId: variation.variationId,
                  weightInGram: variation.weightGram,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                  validate: {
                    sku: "",
                    upc: "",
                    isDisabledSKU: true
                  },
                  nameOption: Array.isArray(combinations[index])
                    ? combinations[index].join("-") : combinations[index],
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                };
              } else {
                return {
                  ...variation,
                  nameOption: variation.name,
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.values[0],
                    };
                  }),
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                  itemVariationId: variation.variationId,
                  weightInGram: 0,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                };
              }
            }),
          };
        } else {
          return {}
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getDetailItemCompound(params) {
      try {
        const response = await ProductService.getDetailItem(params);
        if (response.success) {
          let importPrice = 0
          let exportPrice = 0
          response.data.prices.map((vl,idx)=>{
            if(vl.priceTypeCode === 'PRICE_IMPORT'){
              importPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
            if(vl.priceTypeCode === 'PRICE_EXPORT'){
              exportPrice = this.formatMoneyNotUnit(this.divisionThousand(response.data.prices[idx].amount))
            }
          })

          return {
            ...response.data,
            appSubKey: "",
            selected: false,
            id: response.data.itemId,
            weightInGram: response.data.variations[0].weightGram,
            categoryId: response.data.category.categoryId,
            images: response.data.images.length == 0 
              ? [''] : response.data.images,
            validate: {
              sku: "",
              upc: "",
              isDisabledSKU: true,
              category: "",
              categorySub: "",
            },
            metaSearchable: {
              ...response.data.metaSearchable,
              statusDefault:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? false
                  : true,
              statusImei:
                response.data.metaSearchable.useImeiAndSerial == "true"
                  ? true
                  : false,
              isSelling:
                response.data.metaSearchable.isSelling == "true" ? true : false,
            },
            options:
              response.data.options.length > 0 ? response.data.options : [],
            sku: response.data.variations[0].sku,
            upc: response.data.variations[0].upc,
            optimisticVersion: response.data.version,
            prices: response.data.prices,
            priceItem:
              response.data.prices.length > 0
                ? {
                    name: response.data.name,
                    exportPrice: exportPrice,
                    importPrice: importPrice,
                  }
                : {
                    name: response.data.name,
                    exportPrice: 0,
                    importPrice: 0,
                  },
            warranty: {
              ...response.data.warranty,
              warrantyName: response.data.warranty.description,
            },
            variations: response.data.variations.map((variation, index) => {
              let _importPrice = 0
              let _exportPrice = 0
              variation.prices.map((vl,idx)=>{
                if(vl.priceTypeCode === 'PRICE_IMPORT'){
                  _importPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
                if(vl.priceTypeCode === 'PRICE_EXPORT'){
                  _exportPrice = this.formatMoneyNotUnit(this.divisionThousand(variation.prices[idx].amount))
                }
              })

              if (response.data.options.length > 0) {
                let options = response.data.options.map((e) => e.values);
                let combinations = options.reduce((arrA, arrB) =>
                  arrA.reduce(
                    (x, y) => x.concat(arrB.map((e) => [].concat(y, e))),
                    []
                  )
                );
                return {
                  ...variation,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.value,
                      values: [option.value],
                    };
                  }),
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  itemVariationId: variation.variationId,
                  weightInGram: variation.weightGram,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                  validate: {
                    sku: "",
                    upc: "",
                    isDisabledSKU: true
                  },
                  nameOption: Array.isArray(combinations[index])
                    ? combinations[index].join("-") : combinations[index],
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                };
              } else {
                return {
                  ...variation,
                  nameOption: variation.name,
                  images: variation.images.length == 0 
                    ? [''] : variation.images,
                  options: variation.options.map((option) => {
                    return {
                      ...option,
                      value: option.values[0],
                    };
                  }),
                  prices:
                    variation.prices.length > 0
                      ? {
                          name: variation.name,
                          exportPrice: _exportPrice,
                          importPrice: _importPrice,
                        }
                      : {
                          name: variation.name,
                          exportPrice: 0,
                          importPrice: 0,
                        },
                  itemVariationId: variation.variationId,
                  weightInGram: 0,
                  lengthInCentimeter: 0,
                  widthInCentimeter: 0,
                  heightInCentimeter: 0,
                };
              }
            }),
          };
        } else {
          return {}
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
};
